export const CUSTOMIZATIONS_PATH = "/uw/actuarial/conditions";

/** Editor link for a condition, focused on one of its ratings when given. */
export function editorPath(target: { conditionId: number; ratingId: number | null }): string {
  return `${CUSTOMIZATIONS_PATH}/edit?conditionId=${target.conditionId}${target.ratingId !== null ? `&ratingId=${target.ratingId}` : ""}`;
}
